import * as moment from 'moment';

export default (value: string) => {
  return value ? moment(value, 'HH:mm+ZZ').format('H:mm') : '0:00';
};
